module.exports = __webpack_public_path__ + "static/media/search_web_2b.20ed947c.png";